$(() => {
    // описание больших фоток
    $(".js-product-image-big").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".js-product-image-small"
    });
    // описание маленького слайдера
    $(".js-product-image-small").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: ".js-product-image-big",
        focusOnSelect: true
    });
});



// WEBPACK FOOTER //
// ./markup/components/product/image/image.js